import { WISTIA_STORAGE_PREFIX, VIDEO_FINISHED_THRESHOLD } from '../constants';
import type { Video, VideoProgress } from '../types';

export function useVideoProgress() {
  const getProgress = (videoId: string): VideoProgress | null => {
    const key = `${WISTIA_STORAGE_PREFIX}${videoId}`;
    const stored = localStorage.getItem(key);

    if (stored == null) {
      return null;
    }

    try {
      return JSON.parse(stored) as VideoProgress;
    } catch {
      return null;
    }
  };

  const getWatchedStartedCounts = (videos: Video[]): { watched: string[]; started: string[] } => {
    const watched: string[] = [];
    const started: string[] = [];

    for (const video of videos) {
      const progress = getProgress(video.id);

      if (progress == null) {
        continue;
      }

      const watchedRatio = video.duration > 0 ? progress.lastTime / video.duration : 0;
      const isFinished = progress.resumableKey === null || watchedRatio > VIDEO_FINISHED_THRESHOLD;

      if (isFinished) {
        watched.push(video.id);
      } else {
        started.push(video.id);
      }
    }

    return { watched, started };
  };

  return {
    getProgress,
    getWatchedStartedCounts,
  };
}
